import { render, staticRenderFns } from "./roleSet.vue?vue&type=template&id=e76d396c"
import script from "./roleSet.vue?vue&type=script&lang=js"
export * from "./roleSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e76d396c')) {
      api.createRecord('e76d396c', component.options)
    } else {
      api.reload('e76d396c', component.options)
    }
    module.hot.accept("./roleSet.vue?vue&type=template&id=e76d396c", function () {
      api.rerender('e76d396c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/roleSet.vue"
export default component.exports